import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ridango-customer-account-change-password-aside',
  templateUrl: './customer-account-change-password-aside.component.html',
  styleUrls: ['./customer-account-change-password-aside.component.scss']
})
export class CustomerAccountChangePasswordAsideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
